import { Input, Text } from '@atoms/index';
import { getNumberWithComma } from '@helpers/miscelleanous';
import { Slider } from '@ui/atoms/design-system/slider';
import ToolTip from '@ui/atoms/design-system/tool-tip';
import { tooltipPlacement } from '@ui/atoms/utils/enums';
import { cn } from '@ui/atoms/utils/utils';
import { getShortNumber } from '@ui/helpers/miscelleanous';

const CalculatorInput = ({ id, field, onChangeCalculatorInput, onBlur }) => {
    const {
        fieldName,
        value,
        prefix = null,
        suffix = null,
        width,
        sliderInterval,
        minValue,
        maxValue,
        showSlider = true,
        error = null,
        toolTip = null,
        shouldFormatValue = false,
        maxLength,
        decimalLength = 2,
        className,
        showLimit,
        suffixSingular = null
    } = field;

    const onChangeSlider = (value) => onChangeCalculatorInput(id, value[0]);

    const sanitizeValue = (value) => {
        if (shouldFormatValue && value) {
            value = parseInt(value.split(',').join(''));
        }

        if (isNaN(value)) return null;

        const parts = value.toString().split('.');
        if (parts.length > 1 && parts[1].length > decimalLength) return null;

        return value;
    };

    const onChangeInput = (event) => {
        const value = sanitizeValue(event.target.value);
        if (value !== null) {
            onChangeCalculatorInput(id, value);
        }
    };

    const onBlurInput = (event) => {
        const value = sanitizeValue(event.target.value);
        if (value !== null) {
            onBlur(id, value);
        }
    };

    return (
        <div className="flex flex-col">
            <div className="flex items-center justify-between gap-6">
                <div className="flex items-center">
                    <Text
                        content={fieldName}
                        className="text-gray-700 p4-medium"
                    />
                    {toolTip ? (
                        <ToolTip
                            description={toolTip}
                            placement={tooltipPlacement.TOP_START}
                            isInnerHtml={true}
                        />
                    ) : null}
                </div>
                <div className="flex items-end gap-1">
                    {prefix ? (
                        <Text
                            content={prefix}
                            className="text-gray-900 p4-regular"
                        />
                    ) : null}
                    <Input
                        register={() => { }}
                        id={id}
                        value={
                            shouldFormatValue && value !== ''
                                ? getNumberWithComma(value)
                                : value
                        }
                        width={width}
                        maxLength={maxLength}
                        onChange={onChangeInput}
                        inputpaddingClassName="p-0"
                        inputMarginClassName="m-0"
                        height="h-5"
                        borderRadius="rounded-none"
                        className={cn(
                            'p4-medium text-gray-900 text-right focus:ring-0',
                            className
                        )}
                        borderWeight="border-0 border-b"
                        borderColor={
                            error
                                ? 'border-semantic-error-base'
                                : 'border-gray-300'
                        }
                        onBlur={onBlurInput}
                    />
                    {suffix ? (
                        <Text
                            content={value > 1 ? suffix || "" : suffixSingular || suffix || ""}
                            className="text-gray-900 p4-regular"
                        />
                    ) : null}
                </div>
            </div>
            <div className="flex justify-end h-5 py-0.5">
                {error ? (
                    <Text
                        content={error}
                        className="text-semantic-error-base p5-medium"
                    />
                ) : null}
            </div>
            {showSlider ? (
                <Slider
                    step={sliderInterval}
                    value={[value]}
                    onChange={onChangeSlider}
                    min={minValue}
                    max={maxValue}
                />
            ) : null}
            {showLimit && (
                <div className="flex items-center justify-between w-full mt-1">
                    <div className="border-l border-gray-400 pt-1.5 pl-1.5 p7-medium text-gray-600">
                        {`${prefix || " "}${getShortNumber(minValue)} ${minValue > 1 ? suffix || "" : suffixSingular || suffix || ""}`}
                    </div>
                    <div className="border-r border-gray-400 pt-1.5 pr-1.5 p7-medium text-gray-600">
                        {`${prefix || " "}${getShortNumber(maxValue)} ${suffix || ""}`}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalculatorInput;
